/* ============================================================
   GOODE GENES BEAUTY — theme.js
   All interactive JS in a separate file to comply with
   Shopify's Content Security Policy in the Theme Editor
   ============================================================ */

(function() {
  'use strict';

  /* ── Mobile Navigation ── */
  function initNav() {
    var hamburger = document.getElementById('nav-hamburger');
    var drawer    = document.getElementById('nav-drawer');
    var closeBtn  = document.getElementById('nav-drawer-close');
    if (!hamburger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', function() {
      drawer.classList.contains('open') ? closeDrawer() : openDrawer();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Close drawer when a link inside it is clicked */
    drawer.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeDrawer);
    });

    /* Desktop Shop Now button visibility */
    var shopBtn = document.getElementById('nav-shop-btn');
    function checkShopBtn() {
      if (shopBtn) shopBtn.style.display = window.innerWidth >= 1024 ? 'inline-block' : 'none';
    }
    checkShopBtn();
    window.addEventListener('resize', checkShopBtn);
  }

  /* ── Cart Toast Notification ── */
  var toast     = null;
  var toastMsg  = null;
  var toastTimer;

  function initToast() {
    toast    = document.getElementById('ggb-cart-toast');
    toastMsg = document.getElementById('ggb-toast-msg');

    /* Dismiss button */
    var dismissBtn = toast ? toast.querySelector('[data-toast-dismiss]') : null;
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function() {
        toast.style.display = 'none';
      });
    }
  }

  function showToast(msg) {
    if (!toast || !toastMsg) return;
    toastMsg.textContent = msg;
    toast.style.display = 'flex';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      toast.style.display = 'none';
    }, 5000);
  }

  function updateCartCount(count) {
    /* Update all cart count elements */
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
    /* Update nav cart link text */
    var cartLink = document.querySelector('.nav-cart-link');
    if (cartLink) {
      cartLink.textContent = count > 0 ? 'Cart (' + count + ')' : 'Cart';
    }
  }

  /* ── AJAX Add to Cart ── */
  function initCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.classList.contains('atc-form')) return;
      e.preventDefault();

      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;

      var id  = idInput.value;
      var btn = form.querySelector('[type="submit"]');
      if (!btn) return;

      var txtNormal = btn.querySelector('.btn-text');
      var txtAdding = btn.querySelector('.btn-adding');
      var txtAdded  = btn.querySelector('.btn-added');

      /* Loading state */
      if (txtNormal) txtNormal.style.display = 'none';
      if (txtAdding) txtAdding.style.display = 'inline';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(item) {
        /* Success */
        if (txtAdding) txtAdding.style.display = 'none';
        if (txtAdded)  txtAdded.style.display  = 'inline';
        showToast('\u201c' + item.title + '\u201d added to bag!');

        /* Refresh cart count */
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        setTimeout(function() {
          if (txtAdded)  txtAdded.style.display  = 'none';
          if (txtNormal) txtNormal.style.display  = 'inline';
          btn.disabled = false;
        }, 2500);
      })
      .catch(function(err) {
        /* Graceful fallback — native form POST always works */
        console.warn('GGB: AJAX cart failed, falling back to form POST:', err);
        form.submit();
      });
    });
  }

  /* ── Product Page Thumbnail Switcher ── */
  function initProductGallery() {
    var mainImg = document.getElementById('main-product-img');
    if (!mainImg) return;

    document.querySelectorAll('.product-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var newSrc = this.getAttribute('data-full');
        if (!newSrc) newSrc = this.src.replace('_200x200', '_900x900');
        mainImg.src = newSrc;
        document.querySelectorAll('.product-thumb').forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      });
    });
  }

  /* ── Cart Page Quantity Controls ── */
  function initCartQty() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-cart-change]');
      if (!btn) return;

      var key    = btn.getAttribute('data-key');
      var qty    = parseInt(btn.getAttribute('data-qty'), 10);
      if (!key) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (qty === 0 || cart.item_count === 0) {
          window.location.reload();
          return;
        }
        /* Update qty display */
        var safeKey = key.replace(/:/g, '-');
        var qtyEl = document.getElementById('qty-' + safeKey);
        if (qtyEl) qtyEl.textContent = qty;

        /* Update total */
        var totalEl = document.getElementById('cart-total');
        if (totalEl && cart.total_price !== undefined) {
          var formatted = (cart.total_price / 100).toLocaleString('en-US', {
            style: 'currency', currency: cart.currency || 'USD'
          });
          totalEl.textContent = formatted;
        }
        updateCartCount(cart.item_count);
      })
      .catch(function() { window.location.reload(); });
    });
  }

  /* ── Smooth scroll for anchor links ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var navHeight = document.querySelector('.site-nav') ?
          document.querySelector('.site-nav').offsetHeight : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - navHeight - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ── Init on DOM ready ── */
  function init() {
    initNav();
    initToast();
    initCart();
    initProductGallery();
    initCartQty();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Shopify Theme Editor live reload support ── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

})();
